import {Box, Stack, Typography} from '@mui/material';
import {ReactNode} from 'react';

interface PageHeaderProps {
    title: ReactNode;
    subtitle?: ReactNode;
    action?: ReactNode;
}

export const PageHeader = ({title, subtitle, action}: PageHeaderProps) => (
    <Stack
        direction={{xs: 'column', md: 'row'}}
        alignItems={{xs: 'stretch', md: 'center'}}
        justifyContent="space-between"
        spacing={2}
        sx={{mb: {xs: 2.5, md: 3}}}
    >
        <Box minWidth={0}>
            <Typography component="h1" variant="h2">{title}</Typography>
            {subtitle && <Typography color="text.secondary" sx={{mt: 0.5}}>{subtitle}</Typography>}
        </Box>
        {action && <Box sx={{flexShrink: 0, '& > .MuiButton-root': {width: {xs: '100%', md: 'auto'}}}}>{action}</Box>}
    </Stack>
);
